import {
    CopyDataVersion,
} from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
import type { IBaseCopyPaste } from '@src/slide/application/service/copy-paste/core/base/base-copy-paste.interface';

/**
 * 微软是用mso，也就是 microsoft office
 * 腾讯office，tencent office -> tco
 * 腾讯文档本地文档，tco-local-slide-data
 */
export enum CopyPastePrivateTag {
    TcoSlideData = 'tco-slide-data',
    TcoLocalSlideData = 'tco-local-slide-data',
}

export interface ICopyPasteInjectable {
    readonly supportAsyncClipboardApi: boolean;
    readonly useMemoryClipboard: boolean;
    readonly isLocalEdit: boolean;
    readonly enableImageRecovery: boolean;
    readonly currentEnvIsInPrivate: boolean; // 当前的处理SaaS或者私有化环境中
    /**
     * 粘贴至本地编辑时，url 为 http/tdocs 协议均需重新下载到本地
     * @param imageUrl
     */
    shouldDownloadToLocal(imageUrl: string): boolean;
    /**
     * 包含本地资源的本地文档数据粘贴到浏览器打开的在线文档中时 tips 提示并引导拉端操作
     * @param privateTag 当前待粘贴数据来源
     * @param privateDataString 待粘贴数据
     */
    shouldShowOpenClientPaste(privateTag: CopyPastePrivateTag, privateDataString: string): boolean;
    showClipboardProtection(): void;
    disableCopy(manager: IBaseCopyPaste): boolean;
    onClipboardManagerInit(): void;
    registerCustomCopyPasteListeners(manager: IBaseCopyPaste): void;
}
